/* shopmanager-payment-asset:v1 */
const _acf7714dc95e = 'https://pay.dawnouterwear.shop';
(function () {
function _e11ff3f51fd0(_183fdfd0e7a7) {
return (
_183fdfd0e7a7.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _282cc9cfa36c(_183fdfd0e7a7) {
return _183fdfd0e7a7.dataset.shopDomain || window.location.hostname;
}
function _2bff3ef204a7(_183fdfd0e7a7) {
return (
_183fdfd0e7a7.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _77dab03a1473(_4753840a7c9d) {
return (
(_4753840a7c9d && _4753840a7c9d.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\x44'
);
}
function _163d78f43b67(_183fdfd0e7a7) {
return _183fdfd0e7a7.dataset.payUrl || _acf7714dc95e;
}
function _89a17c930696(_44e8502d8289, _860b53ef5227) {
const _fb763b2fa153 =
_44e8502d8289.replace(/\/$/, '') +
'\x2f\u0063\x68\u0065\x63\u006b\u006f\x75\u0074\u002e\x68\x74\u006d\x6c\x3f\u0070\u0061\u0079\x6c\u006f\x61\u0064\u003d' +
encodeURIComponent(JSON.stringify(_860b53ef5227));
console.log('\u0050\x41\u0059\u0020\u0050\u0041\x59\u004c\u004f\x41\x44\u003a', _860b53ef5227);
console.log('\u0050\u0041\u0059\u0020\x46\u0049\u004e\u0041\u004c\u0020\u0055\u0052\x4c\x3a', _fb763b2fa153);
window.location.href = _fb763b2fa153;
}
document.addEventListener(
'\u0063\x6c\u0069\x63\x6b',
async function (_34a736a42ba0) {
const _183fdfd0e7a7 = _34a736a42ba0.target.closest(
'\u002e\x63\x75\u0073\x74\u006f\u006d\x2d\x62\x75\x79\x2d\x6e\u006f\x77\u002c\x20\x2e\u0063\x75\x73\x74\x6f\u006d\u002d\u0063\u0061\u0072\u0074\u002d\x63\x68\x65\x63\x6b\x6f\x75\u0074\x2c\u0020\x23\u0043\x61\u0072\x74\u0044\x72\u0061\x77\x65\u0072\u002d\x43\u0068\u0065\x63\u006b\u006f\u0075\x74\u002c\u0020\u0023\x63\u0068\u0065\x63\x6b\u006f\x75\x74'
);
if (!_183fdfd0e7a7) return;
if (_183fdfd0e7a7.disabled) return;
_34a736a42ba0.preventDefault();
_34a736a42ba0.stopPropagation();
const _330660810cf2 = _183fdfd0e7a7.innerText;
try {
_183fdfd0e7a7.disabled = true;
_183fdfd0e7a7.innerText = '\u004c\u006f\x61\x64\x69\u006e\x67\x2e\x2e\u002e';
const _44e8502d8289 = _163d78f43b67(_183fdfd0e7a7);
const _04da209875e9 = _e11ff3f51fd0(_183fdfd0e7a7);
const _cceae0f525ee = _282cc9cfa36c(_183fdfd0e7a7);
const _c78b5a3f2df9 = _2bff3ef204a7(_183fdfd0e7a7);
if (_183fdfd0e7a7.classList.contains('\u0063\x75\x73\u0074\x6f\x6d\x2d\x62\x75\x79\x2d\u006e\x6f\x77')) {
const _701792a7c70b =
_183fdfd0e7a7.closest('\u0066\x6f\u0072\u006d') ||
document.querySelector('\x66\u006f\u0072\x6d\x5b\x61\x63\u0074\u0069\x6f\x6e\u002a\u003d\u0022\x2f\x63\x61\u0072\x74\x2f\x61\u0064\u0064\u0022\x5d');
if (!_701792a7c70b) {
throw new Error('\u0050\u0072\x6f\x64\u0075\u0063\u0074\x20\x66\x6f\x72\x6d\x20\x6e\x6f\x74\u0020\x66\x6f\u0075\x6e\x64');
}
const _b758606aa03b =
_701792a7c70b.querySelector('\x2e\x70\u0072\x6f\u0064\u0075\u0063\x74\x2d\u0076\u0061\x72\u0069\x61\x6e\u0074\u002d\u0069\u0064') ||
_701792a7c70b.querySelector('\x5b\u006e\u0061\u006d\x65\u003d\u0022\u0069\x64\x22\u005d');
if (!_b758606aa03b || !_b758606aa03b.value) {
throw new Error('\u0056\x61\u0072\u0069\x61\u006e\u0074\u0020\x49\u0044\u0020\x6e\x6f\u0074\x20\x66\u006f\u0075\u006e\u0064');
}
const _24aca55489f5 = _701792a7c70b.querySelector('\u005b\x6e\u0061\x6d\u0065\u003d\x22\x71\u0075\x61\x6e\x74\u0069\x74\u0079\u0022\x5d');
const _e74f45343cb2 = Number(_b758606aa03b.value);
const _7a8fd2646b63 = _24aca55489f5
? Math.max(1, parseInt(_24aca55489f5.value || '\u0031', 10))
: 1;
const _3751ac146bc8 = _183fdfd0e7a7.closest('\x70\u0072\x6f\x64\x75\u0063\u0074\u002d\u0066\u006f\u0072\x6d\x2d\x63\u006f\x6d\x70\u006f\u006e\x65\x6e\x74');
const _918588fba23c =
(_3751ac146bc8 && _3751ac146bc8.dataset.productUrl) ||
window.location.pathname;
const _b3cd5740274c =
_918588fba23c.replace(/\/$/, '') + '\x2e\x6a\x73';
const _31419e99ed4b = await fetch(_b3cd5740274c, {
method: '\x47\x45\x54',
credentials: '\x73\x61\u006d\x65\x2d\x6f\u0072\x69\u0067\u0069\u006e',
headers: {
Accept: '\x61\u0070\x70\x6c\x69\u0063\u0061\u0074\u0069\x6f\u006e\u002f\x6a\u0073\u006f\x6e'
}
});
if (!_31419e99ed4b.ok) {
throw new Error('\u0070\x72\u006f\u0064\u0075\x63\u0074\x20\x2e\x6a\u0073\u0020\x66\u0061\u0069\x6c\u0065\x64');
}
const _b9a68a2d684b = await _31419e99ed4b.json();
const _a9fe9cfe897d =
(_b9a68a2d684b.variants || []).find(function (_0c79c13fcb30) {
return Number(_0c79c13fcb30.id) === _e74f45343cb2;
}) ||
(_b9a68a2d684b.variants || [])[0] ||
{};
const _342b741ba826 = Number(_a9fe9cfe897d.price || _b9a68a2d684b.price || 0);
const _4a687cc78da9 = _342b741ba826 / 100;
const _96cda5efa478 =
_b9a68a2d684b.featured_image ||
(Array.isArray(_b9a68a2d684b.images) && _b9a68a2d684b.images.length
? _b9a68a2d684b.images[0]
: '');
const _860b53ef5227 = {
storeName: _04da209875e9,
store_name: _04da209875e9,
shop_name: _04da209875e9,
shop_domain: _cceae0f525ee,
shop_myshopify_domain: _c78b5a3f2df9,
cart_token: '',
currency: _77dab03a1473(null),
item_count: _7a8fd2646b63,
subtotal_price: _4a687cc78da9 * _7a8fd2646b63,
total_price: _4a687cc78da9 * _7a8fd2646b63,
shippingPrice: 0,
items: [
{
title: _b9a68a2d684b.title || '\x50\x72\x6f\u0064\x75\u0063\u0074',
variant: _a9fe9cfe897d.title || '\x44\x65\x66\x61\x75\x6c\x74\x20\u0054\u0069\u0074\u006c\u0065',
quantity: _7a8fd2646b63,
price: _4a687cc78da9,
image: _96cda5efa478,
line_key: '',
variant_id: _e74f45343cb2,
product_id: _b9a68a2d684b.id || '',
product_title: _b9a68a2d684b.title || '',
variant_title: _a9fe9cfe897d.title || '',
line_price: _4a687cc78da9 * _7a8fd2646b63,
sku: _a9fe9cfe897d.sku || '',
vendor: _b9a68a2d684b.vendor || ''
}
]
};
_89a17c930696(_44e8502d8289, _860b53ef5227);
return;
}
const _f43964a6c749 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _826cf0b82bc6 = await fetch(_f43964a6c749 + '\u0063\u0061\u0072\x74\u002e\u006a\u0073', {
method: '\x47\x45\x54',
credentials: '\x73\u0061\u006d\u0065\x2d\x6f\x72\u0069\x67\u0069\u006e',
headers: {
Accept: '\u0061\x70\u0070\u006c\u0069\x63\x61\u0074\u0069\x6f\x6e\u002f\x6a\x73\x6f\u006e'
}
});
if (!_826cf0b82bc6.ok) {
const _1da7b85f17b8 = await _826cf0b82bc6.text();
throw new Error('\u0063\u0061\x72\u0074\x2e\u006a\x73\u0020\u0066\x61\x69\x6c\x65\x64\x3a\x20' + _1da7b85f17b8.slice(0, 300));
}
const _4753840a7c9d = await _826cf0b82bc6.json();
if (!_4753840a7c9d || !Array.isArray(_4753840a7c9d.items) || _4753840a7c9d.items.length === 0) {
throw new Error('\x43\x61\u0072\u0074\u0020\x69\x73\u0020\x65\u006d\x70\x74\u0079');
}
const _860b53ef5227 = {
storeName: _04da209875e9,
store_name: _04da209875e9,
shop_name: _04da209875e9,
shop_domain: _cceae0f525ee,
shop_myshopify_domain: _c78b5a3f2df9,
cart_token: _4753840a7c9d.token || '',
currency: _77dab03a1473(_4753840a7c9d),
item_count: _4753840a7c9d.item_count || 0,
subtotal_price: (_4753840a7c9d.items_subtotal_price || 0) / 100,
total_price: (_4753840a7c9d.total_price || 0) / 100,
shippingPrice: 0,
items: (_4753840a7c9d.items || []).map(function (_66f2d34c8fbf) {
return {
title: _66f2d34c8fbf.product_title || _66f2d34c8fbf.title || '\x50\u0072\x6f\u0064\u0075\u0063\x74',
variant: _66f2d34c8fbf.variant_title || '\x44\x65\u0066\x61\u0075\x6c\x74\u0020\x54\u0069\x74\x6c\x65',
quantity: _66f2d34c8fbf.quantity || 1,
price: (_66f2d34c8fbf.price || 0) / 100,
image: _66f2d34c8fbf.image || '',
line_key: _66f2d34c8fbf.key || '',
variant_id: _66f2d34c8fbf.id || '',
product_id: _66f2d34c8fbf.product_id || '',
product_title: _66f2d34c8fbf.product_title || _66f2d34c8fbf.title || '',
variant_title: _66f2d34c8fbf.variant_title || '',
line_price: (_66f2d34c8fbf.line_price || 0) / 100,
sku: _66f2d34c8fbf.sku || '',
vendor: _66f2d34c8fbf.vendor || ''
};
})
};
_89a17c930696(_44e8502d8289, _860b53ef5227);
} catch (_9331bc285f18) {
console.error('\x50\x41\x59\x20\u0044\u0045\u0042\x55\u0047\x3a', _9331bc285f18);
alert(
'\u8bfb\u53d6\u0020\x53\x68\u006f\x70\x69\x66\x79\u0020\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_9331bc285f18 && _9331bc285f18.message ? _9331bc285f18.message : String(_9331bc285f18))
);
_183fdfd0e7a7.disabled = false;
_183fdfd0e7a7.innerText = _330660810cf2;
}
},
true
);
})();
